import { Pipe, PipeTransform } from '@angular/core';
import { pad2 } from '@core/utils';

@Pipe({
  name: 'decimalNumber'
})
export class DecimalNumberPipe implements PipeTransform {
  transform(value: string | number): string {
    if (typeof value === 'string') {
      value = Number(value);
    }

    if (typeof value === 'number') {
      value = pad2(Math.round((value % 1) * 100));
    }

    return value;
  }
}
